import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { MobilePMCarousel } from '../../molecules/mobilePMCarousel'
import { DesktopPMCarousel } from '../../molecules/desktopPMCarousel'
import { ResponsiveCSSContainer } from '../../atoms/responsiveContainerCSS'
import { getActiveItems } from '../../../dataManipulation/cmsItems'

const ProductMenuCarousel = (props) => {
  const { slides } = props
  const filteredSlides = getActiveItems(slides)

  const { length } = filteredSlides
  const maxItemsVisible = 4
  const maxIndex = Math.ceil(length / maxItemsVisible)

  const [index, setIndex] = useState(0)

  const onNext = () => {
    const newIndex = index + 1
    if (newIndex < maxIndex) setIndex(newIndex)
    else setIndex(0)
  }

  const onPrevious = () => {
    const newIndex = index - 1
    if (newIndex >= 0) setIndex(newIndex)
    else setIndex(maxIndex - 1)
  }

  if (slides.length !== length) return <></> // If we had slides, but they were all filtered out, stop showing this component
  if (length === 0) return <></>

  return (
    <>
      <ResponsiveCSSContainer showMobile>
        <MobilePMCarousel key={'MobilePMCarousel'} slides={filteredSlides} />
      </ResponsiveCSSContainer>
      <ResponsiveCSSContainer showDesktop>
        <DesktopPMCarousel
          key={'DesktopPMCarousel'}
          slides={filteredSlides}
          index={index}
          onNext={onNext}
          onPrevious={onPrevious}
          maxItemsVisible={maxItemsVisible}
        />
      </ResponsiveCSSContainer>
    </>
  )
}

ProductMenuCarousel.propTypes = {
  slides: PropTypes.arrayOf(
    PropTypes.shape({
      activeTo: PropTypes.number,
      activeFrom: PropTypes.number,
      text: PropTypes.string,
      link: PropTypes.string,
      image: PropTypes.shape({
        url: PropTypes.string,
        alt: PropTypes.string,
      }),
      icon: PropTypes.shape({
        image: PropTypes.shape({
          url: PropTypes.string,
          alt: PropTypes.string,
        }),
      }),
    })
  ),
}

export { ProductMenuCarousel }
